module.exports = __webpack_public_path__ + "img/kintell-logo.729d5f6.svg";